<div id="{{actionIndex}}-action-warning-block"
     [ngClass]="'action-warning-block' + ' ' + coloring">
  <span>Irreversible</span>

  <span class="material-icons notranslate tooltip-icon danger"
        [matTooltip]="message"
        matTooltipClass="mat-tooltip">error_outline</span>
</div>
